import { all, put, call, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import * as actions from './actions';

// *load comp
function* loadComp(action) {
  const {
    data: {
      comp_id,
      division_id,
      department_id,
      section_id,
      plant_id,
      location_visibility,
      accessToken,
    },
  } = action.payload;

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/stock-management-dashboard/load-comp`,
      {
        comp_id,
        division_id,
        department_id,
        section_id,
        plant_id,
        location_visibility,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );

    yield put(actions.loadComp.success(res.data));
  } catch (err) {
    console.log(err.message);
    yield put(actions.loadComp.failure());
  }
}
// *load division
function* loadDivision(action) {
  const {
    data: { comp_id, location_visibility, accessToken },
  } = action.payload;

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/stock-management-dashboard/load-division`,
      {
        comp_id,
        location_visibility,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );

    yield put(actions.loadDivision.success(res.data));
  } catch (err) {
    console.log(err.message);
    yield put(actions.loadDivision.failure());
  }
}

// *load department
function* loadDepartment(action) {
  const {
    data: { division_id, location_visibility, accessToken },
  } = action.payload;

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/stock-management-dashboard/load-department`,
      {
        division_id,
        location_visibility,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );

    yield put(actions.loadDepartment.success(res.data));
  } catch (err) {
    console.log(err.message);
    yield put(actions.loadDepartment.failure());
  }
}

// *load section
function* loadSection(action) {
  const {
    data: { department_id, location_visibility, accessToken },
  } = action.payload;

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/stock-management-dashboard/load-section`,
      {
        department_id,
        location_visibility,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );

    yield put(actions.loadSection.success(res.data));
  } catch (err) {
    console.log(err.message);
    yield put(actions.loadSection.failure());
  }
}

// *load plant
function* loadPlant(action) {
  const {
    data: { section_id, location_visibility, accessToken },
  } = action.payload;

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/stock-management-dashboard/load-plant`,
      {
        section_id,
        location_visibility,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );

    yield put(actions.loadPlant.success(res.data));
  } catch (err) {
    console.log(err.message);
    yield put(actions.loadPlant.failure());
  }
}
// *load data dashboard
function* loadDataDashboard(action) {
  const {
    data: { plant_id, date, filter, location_visibility, accessToken },
  } = action.payload;

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/stock-management-dashboard/load-data-dashboard`,
      {
        plant_id,
        date,
        filter,
        location_visibility,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );

    yield put(actions.loadDataDashboard.success(res.data));
  } catch (err) {
    console.log(err.message);
    yield put(actions.loadDataDashboard.failure());
  }
}
// *load locations near by plant
function* loadLocationsNearbyPlant(action) {
  const {
    data: { lat, lng, plant_id, accessToken },
  } = action.payload;

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/stock-management-dashboard/load-locations-nearby-plant`,
      {
        lat,
        lng,
        plant_id,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );

    yield put(actions.loadLocationsNearbyPlant.success(res.data));
  } catch (err) {
    console.log(err.message);
    yield put(actions.loadLocationsNearbyPlant.failure());
  }
}
export default function* watchIsupplyStockManagementDashboard() {
  yield all([
    takeEvery(actions.LOAD_COMP.REQUEST, loadComp),
    takeEvery(actions.LOAD_DIVISION.REQUEST, loadDivision),
    takeEvery(actions.LOAD_DEPARTMENT.REQUEST, loadDepartment),
    takeEvery(actions.LOAD_SECTION.REQUEST, loadSection),
    takeEvery(actions.LOAD_PLANT.REQUEST, loadPlant),
    takeEvery(actions.LOAD_DATA_DASHBOARD.REQUEST, loadDataDashboard),
    takeEvery(
      actions.LOAD_LOCATIONS_NEARBY_PLANT.REQUEST,
      loadLocationsNearbyPlant
    ),
  ]);
}
export {
  loadComp,
  loadDivision,
  loadDepartment,
  loadSection,
  loadPlant,
  loadDataDashboard,
  loadLocationsNearbyPlant,
};
